import { TOKEN_HTML_TAG } from '../constants';
import { htmlCollectionToArray } from './htmlCollectionToArray';

export const getTokensFromDocument = (doc: Document) => {
  const elementCollection = doc.getElementsByTagName(TOKEN_HTML_TAG);
  return htmlCollectionToArray(elementCollection);
};
